<template>
  <div class="standard-page upload-page">
    <b-form class="file-drop-form">
      <FileInput class="file-drop" id="customer_upload">
        <template #header>
          <h5>Upload your customer data</h5>
        </template>

        <template #footer>
          <p>
            Or
            <br />
            Drag your file into this window
          </p>

          <p>
            <router-link to="#">
              Click here for Customer CSV Template
            </router-link>
          </p>

          <b-button variant="light" type="submit">Upload</b-button>
        </template>
      </FileInput>
    </b-form>
  </div>
</template>

<script>
import FileInput from '@/components/FormInputs/FileInput/FileInput.vue'

export default {
  components: {
    FileInput
  }
}
</script>

<style lang="scss" scoped>
.file-drop-form {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.file-drop {
  padding: 72px 30px;
  flex: 1;
}
</style>
